export const AUTH_LOAD_START = 'auth/AUTH_LOAD_START';
export const AUTH_LOAD_SUCCESS = 'auth/AUTH_LOAD_SUCCESS';
export const AUTH_LOAD_ERROR = 'auth/AUTH_LOAD_ERROR';
